import script from "./AssetDetailPriceContentEditable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetDetailPriceContentEditable.vue?vue&type=script&setup=true&lang=ts"

import "./AssetDetailPriceContentEditable.vue?vue&type=style&index=0&id=2819ea97&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2819ea97"]])

export default __exports__